import { VALID_AWS_REGIONS } from "@p0security/integrations-aws-frontend";
import type { AwsSmComponents } from "@p0security/integrations-aws-sm-shared/components";
import {
  type FrontendInstaller,
  integrationOptionProvider,
} from "@p0security/integrations-installer";

export const awsSmInstaller: FrontendInstaller<typeof AwsSmComponents> = {
  components: {
    "iam-write": {
      optionProvider: integrationOptionProvider("iam-write", [
        { component: "iam-write", integration: "aws" },
      ]),
      items: {
        defaultRegion: {
          optionProvider: async () =>
            [...VALID_AWS_REGIONS].sort().map((r) => ({ id: r })),
        },
      },
    },
  },
};
